import React, { useState } from 'react';
const FAQ = () => {
  const faqs = [{
    question: 'How does SmartSoda improve employee wellness?',
    answer: 'SmartSoda provides alkaline, vitamin-infused, and electrolyte-rich beverages that keep employees hydrated, energized, and focused throughout the workday—without artificial ingredients or excessive sugars.'
  }, {
    question: 'How does SmartSoda support corporate sustainability goals?',
    answer: 'Our AI-powered dispensers eliminate single-use plastics by providing unlimited on-demand beverages, reducing waste, and promoting an eco-friendly workplace.'
  }, {
    question: 'Is SmartSoda cost-effective for businesses?',
    answer: 'Yes! Our dispensers lower beverage costs, eliminate the need for bottled drinks, reduce storage needs, and streamline logistics—saving both time and money.'
  }, {
    question: 'What types of beverages are available?',
    answer: 'SmartSoda offers a wide selection, including flavored waters, sparkling waters, craft sodas, teas, lemonades, sports drinks, and cold brews—with customizable carbonation and functional wellness shots.'
  }, {
    question: 'How does the AI-powered system work?',
    answer: 'Our connected platform tracks usage in real-time and automatically notifies our service team when refills or maintenance are needed—keeping your machine stocked and running smoothly without any effort on your end.'
  }, {
    question: 'Can SmartSoda help bring employees back to the office?',
    answer: 'Absolutely! A fun, engaging workplace experience with premium beverage options boosts employee satisfaction and encourages in-office collaboration.'
  }, {
    question: 'How much space does a SmartSoda dispenser require?',
    answer: 'Our machines are compact and space-saving, replacing cases of bottled drinks and freeing up valuable storage space.'
  }, {
    question: "What's required for installation?",
    answer: 'SmartSoda dispensers connect to your existing water source and power supply, making installation quick and hassle-free, and are made by a professional technician.'
  }, {
    question: 'Is SmartSoda suitable for manufacturing facilities?',
    answer: 'Yes! Our electrolyte-rich hydration options keep workers refreshed and productive, making SmartSoda a great fit for high-energy work environments.'
  }, {
    question: 'How can I get started?',
    answer: 'Contact us today to schedule a consultation and bring SmartSoda to your workplace!'
  }];
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-20 bg-gray-50" id="faq" data-id="element-179">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-182">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-183">
            Everything you need to know about SmartSoda for your office
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-184">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-100 last:border-b-0" data-id="element-185">
              <button className="w-full px-6 py-5 text-left focus:outline-none" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} data-id="element-186">
                <div className="flex justify-between items-center" data-id="element-187">
                  <h3 className="text-lg font-medium text-navy-950" data-id="element-188">
                    {faq.question}
                  </h3>
                  <span className="ml-6 flex-shrink-0" data-id="element-189">
                    <svg className={`h-6 w-6 transform ${openIndex === index ? 'rotate-180' : 'rotate-0'} transition-transform duration-200 ease-in-out text-gray-500`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-190">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-191" />
                    </svg>
                  </span>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-192">
                <div className="px-6 text-gray-600" data-id="element-193">{faq.answer}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FAQ;